import React, {useState} from 'react';
import {Button} from '@mui/material';
import {useTranslation} from 'react-i18next';

import AlertComponent from '@components/modal/Alert.component';

interface DeleteAddressModalProps {
  handleClose: () => void;
  handleDelete: () => void;
}

const DeleteAddressModal = (props: DeleteAddressModalProps) => {
  const {handleClose, handleDelete} = props;

  const {t} = useTranslation();

  const [loading, setLoading] = useState(false);

  return (
    <AlertComponent
      title={t('delete.title')}
      description={t('delete.description.address')}
      handleClose={handleClose}
      actions={(
        <>
          <Button variant="outlined" color="primary" disabled={loading} onClick={handleClose}>
            {t('global.cancel')}
          </Button>
          <Button
            variant="contained"
            disabled={loading}
            color="primary"
            onClick={() => {
              setLoading(true);
              handleDelete();
            }}>
            {t('global.delete')}
          </Button>
        </>
      )}/>
  );
};

export default DeleteAddressModal;
